import { render, staticRenderFns } from "./RecentTestsWidget.vue?vue&type=template&id=6b0558b6&"
import script from "./RecentTestsWidget.vue?vue&type=script&lang=js&"
export * from "./RecentTestsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports